"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_i18next_1 = require("react-i18next");
var OptionMessage = function (props) {
    var messageId = props.messageId, values = props.values, optionValue = props.optionValue;
    var t = react_i18next_1.useTranslation().t;
    return react_1.default.createElement("option", { value: optionValue }, t(messageId, values));
};
OptionMessage.propTypes = {
    messageId: prop_types_1.default.string.isRequired,
    optionValue: prop_types_1.default.any.isRequired,
    values: prop_types_1.default.object,
};
exports.default = OptionMessage;
